<h3 mat-dialog-title>Notes Edit</h3>
<mat-dialog-content>
    <quill-editor [modules]="quillModules" (onEditorCreated)='editorInit($event)' [styles]="{height: '350px'}" [(ngModel)]="this.data"></quill-editor>  
</mat-dialog-content>
<mat-dialog-actions align="end" style="margin-top: 30px;">
    <button mat-raised-button color="primary" class="aip-button" (click)="this.save()"
        cdkFocusInitial>OK</button>
    <button mat-raised-button class="aip-button-alt" (click)="close()">Cancel</button>
</mat-dialog-actions>
<!-- Overlay for the dropdowns -->
<div id="selectOverlayDiv" #selectOverlay class="aip-select-overlay" style="position: absolute;"></div>